import { render, staticRenderFns } from "./ToolOrders.vue?vue&type=template&id=1a3f72bc&scoped=true&"
import script from "./ToolOrders.vue?vue&type=script&lang=js&"
export * from "./ToolOrders.vue?vue&type=script&lang=js&"
import style0 from "./ToolOrders.vue?vue&type=style&index=0&id=1a3f72bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f72bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCol,VContainer,VDivider,VRow,VTab,VTabs})
